export default {
  UPDATE_PHONE: 'update_phone',
  VERIFY_PHONE: 'verify_phone',
  UPDATE_SUCCESS: 'update_success',
};
